/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdDomainSettingsLauncherReviewSettings interface.
 */
export function instanceOfFxIdDomainSettingsLauncherReviewSettings(value) {
    return true;
}
export function FxIdDomainSettingsLauncherReviewSettingsFromJSON(json) {
    return FxIdDomainSettingsLauncherReviewSettingsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsLauncherReviewSettingsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'DaysSinceInstall': json['DaysSinceInstall'] == null ? undefined : json['DaysSinceInstall'],
        'Percent': json['Percent'] == null ? undefined : json['Percent'],
        'TestMode': json['TestMode'] == null ? undefined : json['TestMode'],
        'DaysSinceLastReview': json['DaysSinceLastReview'] == null ? undefined : json['DaysSinceLastReview'],
    };
}
export function FxIdDomainSettingsLauncherReviewSettingsToJSON(json) {
    return FxIdDomainSettingsLauncherReviewSettingsToJSONTyped(json, false);
}
export function FxIdDomainSettingsLauncherReviewSettingsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'DaysSinceInstall': value['DaysSinceInstall'],
        'Percent': value['Percent'],
        'TestMode': value['TestMode'],
        'DaysSinceLastReview': value['DaysSinceLastReview'],
    };
}
//# sourceMappingURL=FxIdDomainSettingsLauncherReviewSettings.js.map